import { useGetMarginRatio } from "@/app/hooks/trade/marginRatio";
import { TradeText } from "./styles";
import { COLORS } from "@/app/constants/STYLES";


const TradeMarginRatio = ({ item }: any) => {
    const marginRatio = useGetMarginRatio(item)

    return  (
        <TradeText
            style={{
                letterSpacing: 0,
                minWidth: 90,
                lineHeight: 1,
                flexDirection: 'column',
                alignItems: 'left',
                color: marginRatio > 80 ? COLORS.lightRed : marginRatio > 50 ? '#f87943' : 'inherit'
            }}
        >
            {marginRatio.toFixed(2)}%
        </TradeText>
    )
}

export default TradeMarginRatio;